import React from 'react';
import Lottie from "lottie-react";
import mailSend from "../mailSend.json";

const Animation = () => {
  return <Lottie animationData={mailSend} className="lottie-animation" />;
};

export default Animation;